import React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import PrivacyStatement from './PrivacyStatement'
import LegalNotice from './LegalNotice'
import TermsOfUse from './TermsOfUse'
import PropTypes from 'prop-types'

const ScrollDialogComponent = (props) => {
  const [open, setOpen] = React.useState(props.setOpen)

  const scroll = 'paper'

  const handleClose = () => {
    setOpen(false)
    props.onChange(undefined, false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={scroll}
      aria-labelledby='scroll-dialog-title'
      aria-describedby='scroll-dialog-description'
      fullWidth
      maxWidth='md'
    >
      <DialogTitle variant='titleMedium' id='scroll-dialog-title'>
        {props.header}
      </DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
        {props.header.includes('Privacy') && (
          <div>
            <PrivacyStatement />
          </div>
        )}
        {props.header.includes('Terms') && <TermsOfUse />}
        {props.header.includes('Legal') && <LegalNotice />}
      </DialogContent>
      <DialogActions style={{justifyContent: 'center'}}>
        <div style={{}} />
        <Button
          variant='contained'
          sx={{
            '&:hover': {
              border: 'none',
              backgroundColor: (theme) => theme.palette.hpPrimarydarkest
            }
          }}
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ScrollDialogComponent.propTypes = {
  header: PropTypes.string,
  setOpen: PropTypes.bool,
  onChange: PropTypes.func
}

export default ScrollDialogComponent
